<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option value="">{{ firstOption }}</option>
    <option v-for="type in selects" :key="type.id" :value="type.id" :selected="type.id == selected">
      {{ type.description }}
    </option>
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectPlanTypes',
  data() {
    return {
      firstOption: this.first ? this.first : 'Todos',
      selects: [],
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
    typesNotAppear: {
      type: Array,
    },
  },
  methods: {
    getData() {
      axios(`${baseApiUrl}/v1/plan-types/all`).then((res) => {
        if (this.typesNotAppear) {
          res.data.forEach((data) => {
            if (this.typesNotAppear.indexOf(data.id) == -1) {
              this.selects.push(data);
            }
          });
        } else {
          this.selects = res.data;
        }
      });
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
